import { render, staticRenderFns } from "./PcCheckmark.vue?vue&type=template&id=05dea8ca&scoped=true"
import script from "./PcCheckmark.vue?vue&type=script&lang=js"
export * from "./PcCheckmark.vue?vue&type=script&lang=js"
import style0 from "./PcCheckmark.vue?vue&type=style&index=0&id=05dea8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dea8ca",
  null
  
)

export default component.exports